module.exports = __webpack_public_path__ + "static/impact-analysis-locations-5bd3e40a12b3867cf55b476f3f44bd80.png";